const $ = require('jquery');
const restFormSubmit = require('./jquery.sophiacloud.restFormSubmit.js');
const displayList = require('./jquery.sophiacloud.displayList.js');
const util = require('./util.js');


var dispatcher = {};
var scl_contextForm;

function initFormulaire( config ) {

    // init form data
    if(!validateConfig(config)){
        throw new Error('wrong lead config');
    }
    hydrateLeadInputs(config.leadConfig);

    // init form validation
    $.fn.extend( { specificFormBehavior: getFormulaireValidation( config ) } );

    ////// TODO: refactor for context
    var formElem = $('form');

    // set create
    formElem.attr( 'restFormHttpMethod', 'POST' );

    restFormSubmit.restfulSubmit( formElem, {
        successCallback: getSuccessCallbackFunction( config ),
        errorCallback: getThisErrorCallbackFunction( config ),
        beforeSendCallback: getBeforeSendCallbackFunction( config ),
        uriOptions : config.uriOptions,
        enrichFormData : config.enrichFormData
    } );

}

function validateConfig( config ){
    if(!config.leadConfig){
        return false;
    }
    if(!config.leadConfig.site_id){
        return false;
    }
    if(!config.leadConfig.site_page_id){
        return false;
    }
    return true;

}


function getBeforeSendCallbackFunction( config ){
    // TODO: configure to parametrize based on config
    var basicFunc = function () {
        $( '.btn' ).hide();
        $( '#divAjaxLoader' ).show();
    };
    return basicFunc;
}

function getFormulaireValidation( config ) {

    var validFunc = function () {

        // Champs obligatoires par défaut
        var validationFieldsDefault = [
            { "field_name": "nom", "field_desc": "Nom" },
            { "field_name": "prenom", "field_desc": "Prénom" },
            // optional as we sometimes base it on checking account data
            // { "field_name": "tel1", "field_desc": "Téléphone" },
            { "field_name": "email", "field_desc": "Email" }
        ];

        // Champs spécifiques obligatoires supplémentaires définis sur la console
        validationFieldsSupp = config['json_validationFields'];

        // Merge des 2 arrays
        var validationFields = validationFieldsDefault;
        if(validationFieldsSupp && validationFieldsSupp.length>0){
            validationFields = validationFieldsDefault.concat( validationFieldsSupp );
        }
        var statusForm = true;
        var allpb_check = [];
        var field_name = "";
        var field_desc = "";

        for ( var i = 0; i < validationFields.length; i++ ) {
            field_name = "[name=" + validationFields[i]['field_name'] + "]";
            field_desc = validationFields[i]['field_desc'];
            if( typeof ($( field_name ).val()) !== "undefined" ){
                if ( $( field_name ).val() == '' ) {
                    statusForm = false;
                    allpb_check.push( {
                        'ref_dom': $( field_name ),
                        'msg': 'Merci de compléter le champ ' + field_desc
                    } );
                } else if (
                    // validate email address format
                    field_name == '[name=email]'
                    &&
                    !$( field_name ).val().match( /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/ )
                ) {
                    statusForm = false;
                    allpb_check.push( {
                        'ref_dom': $( field_name ),
                        'msg': 'Merci de renseigner un email valide'
                    } );
                }
            }
        }



        return { status: statusForm, allpb: allpb_check };

    };
    return validFunc;
}


function getSuccessCallbackFunction( config ) {
    ////// anchor the closure
    var closureConfig = config;
    //var toto_contextForm = scl_contextForm;

    if ( config.stripe ) {
        console.log( 'stripe enabled' )
    }

    if ( config.mySuccessCallback ) {
        return config.mySuccessCallback;
    } else if ( config.paypal ) {
        // LE PAYPAL FORM NE depend plus de cette logique !
        // surtout qu'on ne peut pas a la fois avoir un mySuccess et un paypal...
        return function () {
            var btnClass = config.paypal.btnClass == undefined ? 'btn btn-success' : config.paypal.btnClass;
            var amount = $( '.scl_array_ref[title=summary] [name=total_ttc]' ).val();
            var form_paypal = $( '<form id="paypal-form" action="https://www.paypal.com/fr/cgi-bin/webscr" method="post">' +
                '<input type="hidden" name="cmd" value="_xclick"/>' +
                '<input type="hidden" name="business" value="' + config.paypal_details.business + '"/>' +
                '<input type="hidden" name="currency_code" value="EUR"/>' +
                '<input type="hidden" name="item_name" value="' + config.paypal_details.item_name + '"/>' +
                '<input type="hidden" name="amount" value="' + amount + '"/>' +
                '<button class="' + btnClass + '">' + config.paypal.btnText + '</button>' +
                '</form>' );
            $( config.paypal.btnParent ).append( form_paypal );
            // form_paypal.submit();
        };
    }
    else {
        var successCallbackFunction = function ( dataReceived ) {
            var config = closureConfig;
            $( '#divAjaxLoader' ).hide();
            /***************** TODO: callback for webpack
            if ( config['google_conversion_scl_json'] ) {
                var GoogleCC = config['google_conversion_scl_json'][0];
                require( ['http://www.googleadservices.com/pagead/conversion_async.js'], function ( gas ) {
                    window.google_trackConversion( {
                        google_conversion_id: GoogleCC['google_conversion_id'],
                        google_conversion_language: GoogleCC['google_conversion_language'],
                        google_conversion_format: GoogleCC['google_conversion_format'],
                        google_conversion_color: GoogleCC['google_conversion_color'],
                        google_conversion_label: GoogleCC['google_conversion_label'],
                        google_remarketing_only: GoogleCC['google_remarketing_only']
                    } );
                } );
            }
            ***********************/
            dataRecObj = $.parseJSON( dataReceived );
            if ( ( dataRecObj && dataRecObj.receiver_mail_sent ) || config.unit_test ) {
                var message_obj = $( '<div class="text_page_section form_success_message">' + config['msg_web'] + '</div>' );
            } else {
                var message_obj = $( '<div class="text_page_section form_success_message">Il y a eu un probleme. Veuillez envoyer un email a info@sophiacloud.com.</div>' );
            }
            $( 'form', scl_contextForm ).replaceWith( message_obj );
            $( 'html, body' ).animate( { scrollTop: message_obj.offset().top - 100 }, 2000 );
        };
        return successCallbackFunction;
    }
}

function getThisErrorCallbackFunction( config ) {
    var thisErrorCallbackFunction = function ( elem, dataObj ) {

        $( '#divAjaxLoader' ).hide();
        $( 'form', scl_contextForm ).replaceWith(
            '<div class="text_page_section scl_error"> '
            + 'Il y a eu un probleme. Veuillez envoyer un email a info@sophiacloud.com.'
            + '</div>'
        );

    };
    return thisErrorCallbackFunction;
}

var modifConfigCallback = null;
function modifConfig( config ) {
    if ( this.modifConfigCallback ) {
        return this.modifConfigCallback( config );
    } else {
        return config;
    }
}

function hydrateLeadInputs(leadConfig){
    //// TODO: create hidden inputs on the fly to tack to DOM
   for(var key in leadConfig){
       var selector = '[name='+key+']'; 
        if($(selector).length>0){
            $(selector).val( leadConfig[key] );
        }
   } 
}









    /**************************TODO : webpack revoir fonctionnement services_url
    // feature flag
    if ( config.services_url ) {
        window.ui_labels = {};
        window.ui_labels['item_info'] = {};
        var base_sitepath = 'site_files/' + window.scl_site_config.site_id;
        var thisconfig = config;
        requirejs( [
            'item',
            'handlebars',
            // text = module requirejs pour charger un fichier en mode string
            ////////////////// TODO : parametrize templates path
            'text!' + base_sitepath + '/borealis_item_options.html'
            // item_options_template_text
            ///////////////////////////
        ],
            function ( item, handlebars, item_options_template_text ) {
                $.getJSON( thisconfig.services_url, function ( data ) {
                    // not used anymore
                    // var produit_info_array = item.indexServiceToProduitInfo(data);
                    var item_info_array = item.indexServiceToItemInfo( data );
                    item.initDefaultPriceList( item_info_array );
                    // register all partial (item options)
                    var item_options_array = [];
                    $.each( data, function ( i, service ) {
                        if ( undefined == service.contrat_detail_template ) return;
                        $.each( service.contrat_detail_template, function ( j, contrat_detail_template ) {
                            $.each( contrat_detail_template.item, function ( k, item ) {
                                if ( item.item_options_scl_json ) {
                                    var option_label = item.item_options_scl_json[0]['item_options_type'];
                                    if ( option_label && $.inArray( option_label, item_options_array ) == -1 ) {
                                        handlebars.registerPartial( option_label, $( item_options_template_text ).find( '.' + option_label )[0].outerHTML );
                                        item_options_array.push( option_label );
                                    }
                                }
                            } );
                        } );
                    } );
                    if ( typeof ( item.scl_itemObject ) != 'undefined' && typeof dispatcher.initItemOptions == 'function' ) {
                        dispatcher.initItemOptions();
                    }
                    if ( typeof dispatcher.initFormServiceSelection == 'function' ) {
                        dispatcher.initFormServiceSelection( data );
                    }
                } );
            } );
    }
    *****************************************/






module.exports = {
    modifConfig: modifConfig,
    getFormulaireValidation: getFormulaireValidation,
    getThisErrorCallbackFunction: getThisErrorCallbackFunction,
    getSuccessCallbackFunction: getSuccessCallbackFunction,
    initFormulaire: initFormulaire,
    modifConfigCallback: modifConfigCallback,
    dispatcher: dispatcher,
    displayList: displayList,
    restFormSubmit: restFormSubmit,
    util: util
};














